export default "__VITE_ASSET__B6_O8w8j__"